import React, { useState } from 'react';
import kality from '../../../assets/images/icons/kality.jpg';
import Dean from '../../../assets/images/icons/kalityDean.jpg';
import MekeleStudent from '../../../assets/images/icons/mekelestudent.jpg';
import accreditationImage from '../../../assets/images/kal_acc.jpg'; 
import accreditationImage1 from '../../../assets/images/kal_acc.jpg'; 
import AccreditationModal from './AccreditationModal'; // Adjust the import path as necessary

const Kality = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const openModal = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage('');
  };

  return (
    <div>
      <div className="banner-slide">
        <img src={kality} alt="Banner" className="banner-image" />
        <div className="banner-content">
         <h2>Transforming Lives</h2>
          <p>We believe in providing top-quality education and are committed to excellence.</p>
        </div>
      </div>

      <section className="projects-details">
        <div className="auto-container">
          <div className="sec-title style-two">
            <h3>KALITY CAMPUS</h3>
          </div>
          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <h4>MESSAGE FROM CAMPUS DEAN</h4>
                <div className="text">
                  <p>
                    Welcome to Admas University Kality Campus @ <strong>Admas University Kality Campus</strong>, we are committed to 
                    <strong>academic excellence, practical learning, and career-oriented education</strong>. 
                    As a leading private university in Ethiopia, we provide students with the 
                    <strong>knowledge, skills, and hands-on experience</strong> needed to thrive in today’s fast-changing world.
                  </p>
                  <p>
                    Our programs are designed to meet industry demands, offering a blend of 
                    <strong>theoretical knowledge and real-world applications</strong>. 
                    With experienced faculty, state-of-the-art facilities, and a strong focus on student success, 
                    we ensure that our graduates are well-equipped for the job market.
                  </p>
                  <p>
                    Whether you're looking to advance your education, gain professional skills, 
                    or explore new career opportunities, <strong>Admas University Kality Campus</strong> is the 
                    perfect place to start. Join us and be part of an institution that is shaping the 
                    future of education in Ethiopia and beyond.
                  </p>
                  <h4>📍 Admas University Kality Campus – Empowering Your Future!</h4>
                </div>
              </div>
              <div className="col-lg-6">
                <figure className="image pht">
                  <img src={Dean} alt="Dean" />
                  <figcaption>Natnael Siyum (MA)</figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <div className="sec-title style-two">
                  <h4>ACCREDITED PROGRAMS</h4>
                </div>
                <h6>UNDERGRADUATE PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Accounting & Finance</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Business Management</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Marketing Management</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Computer Science</div></li>
                </ul>
                <h6>TVET PROGRAMS</h6>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Business & Finance Level 1 - 4</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Information Technology Level 1 - 4</div></li>
                </ul>
              </div>
              <div className="col-lg-6">
                 <div className="map-container">
         <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.649357418435!2d38.763732072054275!3d9.004375791055955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b85a3b294c027%3A0x5c059416ab392b2a!2zQWRtYXMgVW5pdmVyc2l0eSBIZWFkIE9mZmljZSB8IERlbWJlbCB8IOGKoOGLteGIm-GItSDhi6nhipLhiajhiK3hiLXhibIg4YuL4YqTIOGImC_hiaThibUgfCDhi7DhiJ3hiaDhiI0!5e0!3m2!1sen!2set!4v1744794076394!5m2!1sen!2set" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" // <- Paste your actual embed URL here
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Admas University Meskel Campus Location"
  ></iframe>
      </div>
                <div className="accreditation">
                  <h5>CERTIFICATE OF ACCREDITATION</h5>
                  <img 
                    src={accreditationImage} 
                    alt="Accreditation Letter 1" 
                    style={{ width: '150px', cursor: 'pointer', marginRight: '10px' }} 
                    onClick={() => openModal(accreditationImage)} 
                  />
                  <img 
                    src={accreditationImage1} 
                    alt="Accreditation Letter 2" 
                    style={{ width: '150px', cursor: 'pointer' }} 
                    onClick={() => openModal(accreditationImage1)} 
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="text-block-two">
            <div className="row">
              <div className="col-lg-6">
                <h4>STUDENT LIFE @ KALITY CAMPUS, ADDIS ABABA</h4>
                <div className="text">
                  Discover what it's like to be a student at Kality Campus — from academic excellence to vibrant social life. Our campus in Addis Ababa offers modern facilities, engaging student communities, and a supportive learning environment that helps you thrive both personally and professionally.
                </div>
              </div>
              <div className="col-lg-6">
                <div className="image"><img src={MekeleStudent} alt="Student Life" /></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AccreditationModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        images={[accreditationImage, accreditationImage1]} 
      />
    </div>
  );
};

export default Kality;